<div class="text-input-container">
  <mat-form-field appearance="outline" class="text-field">
    <mat-label>{{ label | translate }}</mat-label>

    <textarea
      matInput
      class="text-area"
      rows="5"
      maxlength="400"
      [placeholder]="placeholder"
      [disabled]="!isEditable || isDisabled"
      [value]="value"
      (input)="onTextareaInput($event)"
      (blur)="onInputBlur()"
    ></textarea>

    <mat-hint align="end" class="counter-hint">{{ value.length }} / 400</mat-hint>

    <ng-container *ngIf="isEditable && withSubmit">
      <app-button
        style="float: right; padding-bottom: 1rem;"
        (click)="saveEditedText(value)"
        [label]="'contact_modal.submit_button' | translate"
        [size]="ButtonSize.SMALL"
        [state]="!isTextEdited(value) ? ButtonState.DISABLED : ButtonState.REGULAR"
        [type]="ButtonType.PRIMARY"
      ></app-button>
    </ng-container>
  </mat-form-field>
</div>
